import { getDocumentElements } from "../../services/documentService";
import {
  setDocumentElements,
  setError,
  setLoading,
} from "../slices/documentSlice";
import { AppThunk } from "../store";

/**
 * Always refetches — no already-loaded short-circuit like the attachment
 * thunk, because the rows carry presigned download URLs that expire.
 */
export const fetchDocumentElements =
  (inspectionId: string): AppThunk =>
  async (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(false));

    try {
      const documentElements = await getDocumentElements(inspectionId);
      dispatch(setDocumentElements(documentElements));
    } catch {
      dispatch(setError(true));
    } finally {
      dispatch(setLoading(false));
    }
  };
